import React from 'react';
import { string, number, bool, shape, arrayOf } from 'prop-types';
import formatDateDistance from '@magalu/stereo-ui-utils/formatDateDistance';
import { Review } from '../../molecules';
import ReviewCharacteristics from '../ReviewCharacteristics';
import { Container, Divider, TitleName, TitleReview, Description, Recommended, ContainerReview, ContainerReviewCharacteristics } from './review-card.styles';

function ReviewCard({
  title,
  text,
  rating,
  recommended,
  user,
  date,
  characteristics,
  showScoreDesc
}) {
  const recoText = recommended ? 'Sim, eu recomendo esse produto' : 'Não, eu não recomendo esse produto';
  const days = date && formatDateDistance(new Date(date), new Date());
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, {
    "data-testid": "review-card"
  }, /*#__PURE__*/React.createElement(ContainerReview, null, /*#__PURE__*/React.createElement(Review, {
    score: rating,
    width: "20px",
    height: "20px"
  }), /*#__PURE__*/React.createElement(TitleName, null, (user == null ? void 0 : user.name) || 'Anônimo', " - ", /*#__PURE__*/React.createElement("span", null, "H\xE1 ", days)), /*#__PURE__*/React.createElement(TitleReview, {
    bold: true
  }, title), /*#__PURE__*/React.createElement(Description, null, text), /*#__PURE__*/React.createElement(Recommended, {
    reviewOK: recommended
  }, recoText)), /*#__PURE__*/React.createElement(ContainerReviewCharacteristics, null, /*#__PURE__*/React.createElement(ReviewCharacteristics, {
    characteristics: characteristics,
    showScoreDesc: showScoreDesc
  }))), /*#__PURE__*/React.createElement(Divider, null));
}

ReviewCard.defaultProps = {
  user: {
    name: 'Anônimo'
  },
  showScoreDesc: false
};
process.env.NODE_ENV !== "production" ? ReviewCard.propTypes = {
  title: string,
  text: string,
  rating: number,
  recommended: bool,
  user: shape({
    name: string
  }),
  date: string,
  characteristics: arrayOf(shape({
    label: string,
    value: number
  })),
  showScoreDesc: bool
} : void 0;
export default ReviewCard;